/**
 * Device fingerprint via @fingerprintjs/fingerprintjs (visitorId).
 * The agent is loaded once and reused for subsequent calls.
 */

import FingerprintJS from "@fingerprintjs/fingerprintjs";

/** @type {Promise<import('@fingerprintjs/fingerprintjs').Agent> | null} */
let fpAgentPromise = null;

function getAgent() {
  if (!fpAgentPromise) {
    fpAgentPromise = FingerprintJS.load();
  }
  return fpAgentPromise;
}

/**
 * Returns the stable visitor id for this browser, or null if fingerprinting fails.
 *
 * @returns {Promise<string | null>}
 */
export async function getDeviceFingerprint() {
  try {
    const fp = await getAgent();
    const result = await fp.get();
    return result.visitorId;
  } catch {
    return null;
  }
}
